<template>
  <v-dialog :value="visible" persistent max-width="180">
    <v-card>
      <v-card-text class="pa-4 d-flex justify-center align-center">
          <v-progress-circular
            class="mr-2"
            size="24"
            width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
          Carregando...
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'loading',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
